import type { HttpCartDto } from '@/modules/cart/infrastructure/dto/HttpCartRepositoryDto';
import httpClient from '@/modules/cart/services/api/client';
import environment from '@/modules/perseo-billing/environments/environment';

const { INVOICE_URL } = environment;

export async function deleteInvoice(): Promise<{ data: HttpCartDto }> {
  const response = await httpClient.delete(INVOICE_URL);
  return Promise.resolve(response);
}
